import React from "react";
import styles from "./LoadingFixtureSelection.module.scss";

const LoadingFixtureSelection = () => {
  return (
    <div className={styles.loadingFixtureSelection}>
      <div>
        <div className={styles.loadingFixtureSelectionText} />
        <div className={styles.loadingFixtureSelectionText} />
      </div>
      <div />
    </div>
  );
};

export default LoadingFixtureSelection;
